<template>
  <div class="editor" style="position:relative;">
  
 
   

<div style="display:flex;flex-direction: row;align-items: flex-start">
    <div v-if="showField" class="fieldText">{{field}}&nbsp;:-</div>
  {{textBody}} <img @click="showImage=!showImage" :src="imageSrc" :height="imageHeight" style="padding-left:10px;">
  </div>
  </div>
</template>

<script>

export default {
  components: {
   
    
  },
  props: ["collection","textID","saveText",'field','showField'],
  data() {
    return {
      showImage:false
     
    }
  },
  mounted(){
     
        
    },
    computed:{
        imageHeight(){
          if(this.showImage){
            return "auto"
          }else{
            return "20px"
          }
        },
        textElement(){
            return this.$store.getters.getTextElement({collection:this.collection,doc:this.textID})
        },
        imageSrc(){
          return this.textElement[this.field].split('|')[1]
        },
        textBody(){
            if(this.textElement){
                return this.textElement[this.field].split('|')[0]
            }
        },
        loading(){
            return this.$store.getters.loading
        },
        
    },
    methods:{
      

    },
    watch:{
      
    },
  beforeDestroy() {
   
  },
}
</script>
<style lang="scss">
.blue{
  background-color:#00f;
}
.green{
  background-color:#42b983;
}
.editor__content{
  vertical-align:top;
    display: inline-block;
    color:inherit;
    p,ul{
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    }
}
.fieldText{
  display: inline-block;
   
    margin-right:5px;
    vertical-align: top;
   
}
.menububble__button {
   height: 14px;
   position:relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    background: transparent;
    border: 0;
    color: #fff;
    padding: .2rem .5rem;
    margin-right: .2rem;
    border-radius: 3px;
    cursor: pointer;
}

 .menububble {
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    z-index: 20;
    background: #000;
    border-radius: 5px;
    padding: .3rem;
    margin-bottom: .5rem;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 0;
    -webkit-transition: opacity .2s,visibility .2s;
    transition: opacity .2s,visibility .2s;
  
  
}
.menububble.is-active {
    opacity: 1;
    visibility: visible;
}
h1, h2, h3{
  margin-bottom:0px;
}
ul[data-type="todo_list"] {
  margin-top:0px;
  padding-top:0px;
  padding-left: 0;
}
li[data-type="todo_item"] {
  display: flex;
  flex-direction: row;
}
.todo-checkbox {
  border: 2px solid #fff;
  height: 20px;
  width:20px;
  box-sizing: border-box;
  margin-right: 10px;
  margin-top: 20px;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
  border-radius: 0.2em;
  background-color: transparent;
  transition: 0.4s green;
}
.todo-content {
  font-size:18px;
  flex: 1;
}
.todo-content > p:last-of-type {
    margin-bottom: 0;
}
.todo-content > ul[data-type="todo_list"] {
    margin: .5rem 0;
}
li[data-done="true"] > .todo-content > p {
      text-decoration: line-through;
}

li[data-done="true"] > .todo-checkbox {
    background-color: #42b983;
}

li[data-done="false"] {
  text-decoration: none;
}
.menubar{
  position:absolute;
  top:-35px;
  opacity:.9;
  z-index:2;
  border:#fff 1px solid;
  background-color: #000;
    margin-bottom: 1rem;
    -webkit-transition: visibility .2s .4s,opacity .2s .4s;
    transition: visibility .2s .4s,opacity .2s .4s;
}
.menubar__button{
  background-color: #000;
}
</style>